angular.module('ikeweb.locale').factory('localeTopics',

    function() {

        return {
            LOCALE: {
                CHANGED: {
                    name: 'locale.changed'
                }
            }
        };
    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/locale.topics.js
// module id = 478
// module chunks = 0